import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TylenolAutismWrapper from "@components/layouts/tylenolautismWrapper";

export default function TylenolAutismHome(): ReactElement {
    return (
        <TylenolAutismWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Tylenol"
                    domain="TylenolAutism.claims"
                />
            </div>
        </TylenolAutismWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
